<template>
  <v-container class="d-flex align-self-start" fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card tile class="pa-1 pl-0" elevation="0">
          <v-card-title class="display-2 font-weight-black pb-0">
            Archivos Servicios Conexión
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" class="px-3">
        <v-card tile class="pa-1" elevation="0">
          <v-row>
            <v-col cols="12" class="py-1">
              <div class="title">Detalles</div>
            </v-col>
            <v-col cols="12" md="2" class="py-1">
              <v-text-field
                v-model="marca"
                label="Marca"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="py-1">
              <v-text-field
                v-model="modelo"
                label="Modelo"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1" class="py-1">
              <v-text-field
                v-model="placa"
                label="Placa"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" class="py-1">
              <v-text-field
                v-model="servicioConexion.servicio.direccion"
                label="Dirección"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="py-1">
              <v-text-field
                v-model="servicioConexion.servicio.correo"
                label="Correo"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="py-1">
              <v-text-field
                v-model="servicioConexion.servicio.telefono"
                label="Teléfono"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-divider></v-divider>
      </v-col>

      <!-- BUSQUEDA -->
      <v-col cols="12" class="px-3">
        <v-card tile class="pa-1" elevation="0">
          <v-row>
            <v-col cols="12" md="2" align-self="center">
              <v-text-field
                v-model="numeroAsistencia"
                label="Numero de asistencia"
                outlined
                dense
                hide-details
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="text-center">
              <v-btn color="primary" @click="getRutaArchivos"
                >Ver archivos</v-btn
              >
            </v-col>
            <v-col cols="auto" align-self="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    :disabled="!hayArchivosSeleccionados"
                    @click="descargarArchivo"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon large> fas fa-cloud-download-alt </v-icon></v-btn
                  >
                </template>
                <span>Descargar</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="auto" align-self="center" v-if="puedeEliminar">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    :disabled="!hayArchivosSeleccionados"
                    @click="opcionEliminarSeleccionados"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon large> fas fa-trash-alt </v-icon></v-btn
                  >
                </template>
                <span>Eliminar seleccionados</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" class="pa-1 px-4">
        <v-stepper v-model="step" non-linear>
          <v-stepper-header>
            <v-stepper-step editable step="1"> DUI </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="2"> NIT </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="3"> Comprobante </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="4"> Tarjeta IVA </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="5"> Factura </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- DUI -->
            <v-stepper-content step="1">
              <v-row no-gutters class="py-4">
                <v-col cols="12" md="3" class="pa-1" align-self="center">
                  <v-file-input
                    v-model="filesDUI"
                    label="Subir Archivos"
                    multiple
                    hide-details
                    small-chips
                    outlined
                    dense
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="12"
                  md="auto"
                  class="pa-2"
                  align-self="center"
                  color="primary"
                >
                  <v-tooltip right color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        @click="subirArchivos"
                        :disabled="filesDUI.length <= 0"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon large> fas fa-cloud-upload-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedFilesDUI"
                :items="itemsPorCarpeta.DUI.value"
                :headers="headers_archivos"
                fixed-header
                class="elevation-1 mx-1"
                item-key="id"
                show-select
                disable-pagination
              >
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span>
                    {{ formatoFecha(item.lastModifiedDateTime) }}
                  </span>
                </template>
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-icon
                    class="mr-2"
                    color="blue"
                    @click="vistaPrevia(item.id)"
                  >
                    fa-regular fa-folder-open
                  </v-icon>
                </template>
                <template
                  v-slot:[`item.delete`]="{ item }"
                  v-if="puedeEliminar"
                >
                  <v-icon @click="opcionEliminar(item)"
                    >fas fa-trash-alt</v-icon
                  >
                </template>
              </v-data-table>
            </v-stepper-content>

            <!-- NIT -->
            <v-stepper-content step="2">
              <v-row no-gutters class="py-4">
                <v-col cols="12" md="3" class="pa-1" align-self="center">
                  <v-file-input
                    v-model="filesNIT"
                    label="Subir Archivos"
                    multiple
                    hide-details
                    outlined
                    small-chips
                    dense
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="12"
                  md="auto"
                  class="pa-2"
                  align-self="center"
                  color="primary"
                >
                  <v-tooltip right color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        :disabled="filesNIT.length <= 0"
                        @click="subirArchivos"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon large> fas fa-cloud-upload-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedFilesNIT"
                :items="itemsPorCarpeta.NIT.value"
                :headers="headers_archivos"
                fixed-header
                class="elevation-1 mx-1"
                item-key="id"
                show-select
                disable-pagination
              >
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span>
                    {{ formatoFecha(item.lastModifiedDateTime) }}
                  </span>
                </template>
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-icon
                    class="mr-2"
                    color="blue"
                    @click="vistaPrevia(item.id)"
                  >
                    fa-regular fa-folder-open
                  </v-icon>
                </template>
                <template
                  v-slot:[`item.delete`]="{ item }"
                  v-if="puedeEliminar"
                >
                  <v-icon @click="opcionEliminar(item)"
                    >fas fa-trash-alt</v-icon
                  >
                </template>
              </v-data-table>
            </v-stepper-content>
            <!-- COMPROBANTE -->
            <v-stepper-content step="3">
              <v-row no-gutters class="py-4">
                <v-col cols="12" md="3" class="pa-1" align-self="center">
                  <v-file-input
                    v-model="filesComprobante"
                    small-chips
                    label="Subir Archivos"
                    multiple
                    hide-details
                    outlined
                    dense
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="12"
                  md="auto"
                  class="pa-2"
                  align-self="center"
                  color="primary"
                >
                  <v-tooltip right color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        @click="subirArchivos"
                        :disabled="filesComprobante.length <= 0"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon large> fas fa-cloud-upload-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedFilesComprobante"
                :items="itemsPorCarpeta.COMPROBANTE.value"
                :headers="headers_archivos"
                fixed-header
                class="elevation-1 mx-1"
                item-key="id"
                show-select
                disable-pagination
              >
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span>
                    {{ formatoFecha(item.lastModifiedDateTime) }}
                  </span>
                </template>
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-icon
                    class="mr-2"
                    color="blue"
                    @click="vistaPrevia(item.id)"
                  >
                    fa-regular fa-folder-open
                  </v-icon>
                </template>
                <template
                  v-slot:[`item.delete`]="{ item }"
                  v-if="puedeEliminar"
                >
                  <v-icon @click="opcionEliminar(item)"
                    >fas fa-trash-alt</v-icon
                  >
                </template>
              </v-data-table>
            </v-stepper-content>
            <!-- IVA -->
            <v-stepper-content step="4">
              <v-row no-gutters class="py-4">
                <v-col cols="12" md="3" class="pa-1" align-self="center">
                  <v-file-input
                    v-model="filesIVA"
                    label="Subir Archivos"
                    small-chips
                    multiple
                    hide-details
                    outlined
                    dense
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="12"
                  md="auto"
                  class="pa-2"
                  color="primary"
                  align-self="center"
                >
                  <v-tooltip right color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        :disabled="filesIVA.length <= 0"
                        @click="subirArchivos"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon large> fas fa-cloud-upload-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedFilesIVA"
                :items="itemsPorCarpeta.IVA.value"
                :headers="headers_archivos"
                fixed-header
                class="elevation-1 mx-1"
                item-key="id"
                show-select
                disable-pagination
              >
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span>
                    {{ formatoFecha(item.lastModifiedDateTime) }}
                  </span>
                </template>
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-icon
                    class="mr-2"
                    color="blue"
                    @click="vistaPrevia(item.id)"
                  >
                    fa-regular fa-folder-open
                  </v-icon>
                </template>
                <template
                  v-slot:[`item.delete`]="{ item }"
                  v-if="puedeEliminar"
                >
                  <v-icon @click="opcionEliminar(item)"
                    >fas fa-trash-alt</v-icon
                  >
                </template>
              </v-data-table>
            </v-stepper-content>
            <!-- FACTURA -->
            <v-stepper-content step="5">
              <v-row no-gutters class="py-4">
                <v-col cols="12" md="3" class="pa-1" align-self="center">
                  <v-file-input
                    v-model="filesFactura"
                    label="Subir Archivos"
                    small-chips
                    multiple
                    hide-details
                    outlined
                    dense
                  ></v-file-input>
                </v-col>
                <v-col
                  cols="12"
                  md="auto"
                  class="pa-2"
                  color="primary"
                  align-self="center"
                >
                  <v-tooltip right color="primary">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        :disabled="filesFactura.length <= 0"
                        @click="subirArchivos"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon large> fas fa-cloud-upload-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Guardar</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-data-table
                v-model="selectedFilesFactura"
                :items="itemsPorCarpeta.FACTURA.value"
                :headers="headers_archivos"
                fixed-header
                class="elevation-1 mx-1"
                item-key="id"
                show-select
                disable-pagination
              >
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span>
                    {{ formatoFecha(item.lastModifiedDateTime) }}
                  </span>
                </template>
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-icon
                    class="mr-2"
                    color="blue"
                    @click="vistaPrevia(item.id)"
                  >
                    fa-regular fa-folder-open
                  </v-icon>
                </template>
                <template
                  v-slot:[`item.delete`]="{ item }"
                  v-if="$store.state.usuario.idUsuario == 1170"
                >
                  <v-icon @click="opcionEliminar(item)"
                    >fas fa-trash-alt</v-icon
                  >
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_preview" max-width="500">
      <v-card tile>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-img :src="url_preview"></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbar_color" bottom>{{
      mensaje_snackbar
    }}</v-snackbar>

    <v-dialog v-model="dialog_progress_linear" width="300" persistent>
      <v-card>
        <v-progress-linear
          indeterminate
          height="6"
          color="blue"
          stream
          rounded
          striped
        >
        </v-progress-linear>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar" width="500" persistent>
      <v-card>
        <v-card-title>Desea eliminar este archivo?</v-card-title>
        <v-card-text>
          <v-text-field v-model="nombre_archivo" readonly></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarArchivo">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_seleccionados" width="500" persistent>
      <v-card>
        <v-card-title>Desea eliminar los archivos seleccionados?</v-card-title>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarArchivos"
            >Eliminar seleccionados</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { saveAs } from "file-saver";
import JSZip from "jszip";

export default {
  data() {
    return {
      step: "1",
      items_archivos: [],
      id_archivo: null,
      itemsPorCarpeta: {
        DUI: [],
        NIT: [],
        IVA: [],
        COMPROBANTE: [],
        FACTURA: [],
      },
      headers_archivos: [
        { text: "Nombre", value: "name" },
        { text: "Fecha última modificación", value: "lastModifiedDateTime" },
        {
          text: "Eliminar",
          value: "delete",
          align: "center",
          sortable: false,
        },
        {
          text: "Ver archivo",
          value: "action_view",
          align: "center",
          sortable: false,
        },
      ],
      rutasCarpetas: ["DUI", "NIT", "COMPROBANTE", "IVA", "FACTURA"],
      rutaBaseDrive: "",
      numeroAsistencia: null,
      selectedFilesDUI: [],
      selectedFilesNIT: [],
      selectedFilesIVA: [],
      selectedFilesComprobante: [],
      selectedFilesFactura: [],
      filesDUI: [],
      filesNIT: [],
      filesIVA: [],
      filesComprobante: [],
      filesFactura: [],
      dialog_preview: false,
      servicioConexion: {
        servicio: {
          numeroAsistencia: "",
          direccion: "",
          correo: "",
          telefono: "",
        },
        ruta: "",
      },

      //   stop
      items_seleccionados: [],
      snackbar: false,
      mensaje_snackbar: null,
      file_input: [],
      nombre_nuevo_folder: null,
      snackbar_color: "primary",
      local_storage: true,

      url_preview: "",
      item_asistencia: "",
      marca: "",
      modelo: "",
      placa: "",
      dialog_progress_linear: false,

      dialog_eliminar: false, //check
      dialog_eliminar_seleccionados: false,
      nombre_archivo: "",
    };
  },
  computed: {
    puedeEliminar() {
      /*
        1032: GLADYS ISABEL AVALOS
        1051: MILTON VLADIMIR MALDONADO
        1170: VANESSA MENJIVAR
           1: ADMINISTRADOR 
      */
      return (
        (this.$store.state.usuario.idUsuario == 1032 ||
          this.$store.state.usuario.idUsuario == 1051 ||
          this.$store.state.usuario.idUsuario == 1) &&
        this.$store.state.usuario.idUsuario != 1170
      );
    },
    hayArchivosSeleccionados() {
      return (
        this.selectedFilesDUI.length > 0 ||
        this.selectedFilesIVA.length > 0 ||
        this.selectedFilesNIT.length > 0 ||
        this.selectedFilesComprobante.length > 0 ||
        this.selectedFilesFactura.length > 0
      );
    },
  },
  created() {
    this.numeroAsistencia = this.$route.params.id;
    this.listarAsistencia();
    this.getRutaArchivos();
  },
  methods: {
    async verArchivosPorRuta(ruta) {
      if (this.rutaBaseDrive) {
        const rutaDrive = `${this.rutaBaseDrive}/${ruta}`;

        await axios
          .get("api/OneDrive?ruta=" + rutaDrive)
          .then((res) => (this.itemsPorCarpeta[ruta] = res.data))
          .catch((err) => {
            this.snackbar = true;
            this.snackbar_color = "error";
            this.mensaje_snackbar = "No se encontraron archivos";

            console.error(err);
          });
      }

      return;
    },
    async subirArchivos() {
      try {
        const formData = new FormData();
        const requestIndex = 0;
        let ruta = "";

        switch (this.step) {
          case "1": // DUI
            if (this.filesDUI.length > 0) {
              formData.append(`TipoArchivos[${requestIndex}].Ruta`, "DUI");
              this.filesDUI.forEach((archivo, archivoIndex) => {
                formData.append(
                  `TipoArchivos[${requestIndex}].Archivos`,
                  archivo
                );
              });

              ruta = "DUI";
            }
            break;
          case "2": // NIT
            if (this.filesNIT.length > 0) {
              formData.append(`TipoArchivos[${requestIndex}].Ruta`, "NIT");
              this.filesNIT.forEach((archivo, archivoIndex) => {
                formData.append(
                  `TipoArchivos[${requestIndex}].Archivos`,
                  archivo
                );
              });

              ruta = "NIT";
            }
            break;
          case "3": // COMPROBANTE
            if (this.filesComprobante.length > 0) {
              formData.append(
                `TipoArchivos[${requestIndex}].Ruta`,
                "Comprobante"
              );
              this.filesComprobante.forEach((archivo, archivoIndex) => {
                formData.append(
                  `TipoArchivos[${requestIndex}].Archivos`,
                  archivo
                );
              });

              ruta = "COMPROBANTE";
            }
            break;
          case "4": // IVA
            if (this.filesIVA.length > 0) {
              formData.append(`TipoArchivos[${requestIndex}].Ruta`, "IVA");
              this.filesIVA.forEach((archivo, archivoIndex) => {
                formData.append(
                  `TipoArchivos[${requestIndex}].Archivos`,
                  archivo
                );
              });

              ruta = "IVA";
            }
            break;
          case "5": // FACTURA
            if (this.filesFactura.length > 0) {
              formData.append(`TipoArchivos[${requestIndex}].Ruta`, "FACTURA");
              this.filesFactura.forEach((archivo, archivoIndex) => {
                formData.append(
                  `TipoArchivos[${requestIndex}].Archivos`,
                  archivo
                );
              });

              ruta = "FACTURA";
            }
            break;

          default:
            return;
            break;
        }

        const response = await axios.post(
          `/api/OneDrive/${this.numeroAsistencia}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data) {
          this.filesDUI = [];
          this.filesIVA = [];
          this.filesComprobante = [];
          this.filesNIT = [];
          this.filesFactura = [];

          this.snackbar = true;
          this.snackbar_color = "primary";
          this.mensaje_snackbar = "Archivo subido exitosamente a Drive";

          //VALIDAR LA PRIMERA VEZ QUE SE SUBA UNA FACTURA

          if (this.rutaBaseDrive != null && ruta != "") {
            await this.verArchivosPorRuta(ruta);
          }

          if (this.step == "5" || this.step == "3") {
            this.updateSubidoFactura(this.step);
          }
        } else {
          this.snackbar = true;
          this.snackbar_color = "primary";
          this.mensaje_snackbar = "Error al subir los archivos";
        }
      } catch {
        this.snackbar = true;
        this.snackbar_color = "primary";
        this.mensaje_snackbar = "Error al subir os archivos";
      }
    },
    getRutaArchivos() {
      axios
        .get(`api/OneDrive/RutaArchivos/${this.numeroAsistencia}`)
        .then((res) => {
          this.servicioConexion = res.data;

          if (!this.servicioConexion.servicio) {
            this.servicioConexion.servicio = {
              numeroAsistencia: "",
              direccion: "",
              correo: "",
              telefono: "",
            };
          }
          this.rutaBaseDrive = this.servicioConexion.ruta;
          this.getArchivosPorCarpeta();
        })
        .catch((err) => console.error(err));
    },
    updateSubidoFactura(step) {
      const servicio = {
        numeroAsistencia: this.numeroAsistencia,
        esFactura: step == "5" ? true : null,
        esCompEfectivo: step == "3" ? true : null,
        telefono: this.servicioConexion.servicio?.telefono,
        direccion: this.servicioConexion.servicio?.direccion,
        correo: this.servicioConexion.servicio?.correo,
      };

      axios
        .put(`api/ServiciosConexion/${this.numeroAsistencia}`, servicio)
        .then((res) => {})
        .catch((err) => {
          console.error(err);
        });
    },
    async getArchivosPorCarpeta() {
      if (!this.rutaBaseDrive) return null;

      for (const ruta of this.rutasCarpetas) {
        const rutaDrive = `${this.rutaBaseDrive}/${ruta}`;

        await axios
          .get("api/OneDrive?ruta=" + rutaDrive)
          .then((res) => (this.itemsPorCarpeta[ruta] = res.data))
          .catch((err) => {
            this.snackbar = true;
            this.snackbar_color = "error";
            this.mensaje_snackbar = "No se encontraron archivos";

            console.error(err);
          });
      }
    },
    listarAsistencia() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/Cabinas/MostrarCodigoNumAsistencia/" + this.numeroAsistencia,
          configuracion
        )
        .then((response) => {
          this.item_asistencia = response.data;
          this.marca = response.data.marca;
          this.modelo = response.data.modelo;
          this.placa = response.data.placa;
        });
    },
    async vistaPrevia(item) {
      this.dialog_progress_linear = true;

      axios
        .get(`api/OneDrive/VistaPrevia/${item}`)
        .then((res) => {
          if (!res.error) {
            this.url_preview = res.data.value[0].large.url;
            this.dialog_preview = true;
          } else {
            console.error(res.error);
            this.snackbar = true;
            this.snackbar_color = "error";
            this.mensaje_snackbar = "No se enconto una vista previa";
          }
        })
        .catch((err) => {
          console.error(err);
          this.snackbar = true;
          this.snackbar_color = "error";
          this.mensaje_snackbar = "No se enconto una vista previa";
        })
        .finally(() => {
          this.dialog_progress_linear = false;
        });
    },
    async descargarArchivo() {
      this.dialog_progress_linear = true;

      try {
        let zip = new JSZip();
        const selectedFiles = [
          ...this.selectedFilesDUI,
          ...this.selectedFilesNIT,
          ...this.selectedFilesIVA,
          ...this.selectedFilesComprobante,
        ];

        const downloadPromises = selectedFiles.map(async (file) => {
          try {
            const response = await axios.get(
              `api/OneDrive/DescargarArchivo/${file.id}`,
              {
                responseType: "blob",
              }
            );

            zip.file(file.name, response.data);
          } catch (error) {
            this.snackbar = true;
            this.snackbar_color = "error";
            this.mensaje_snackbar = `Error descargando ${file.name}:`;
            console.error(`Error descargando ${file.name}:`, error);
          }
        });

        await Promise.all(downloadPromises);

        zip.generateAsync({ type: "blob" }).then((blob) => {
          saveAs(blob, "Archivos.zip");
        });
      } catch (error) {
        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = "Error general al crear el ZIP";
        console.error("Error general al crear el ZIP:", error);
      } finally {
        this.dialog_progress_linear = false;
      }
    },
    async eliminarArchivo() {
      if (!this.id_archivo) return;

      try {
        const response = await axios.delete(
          `api/OneDrive/EliminarArchivo/${this.id_archivo}`
        );

        if (response.data) {
          this.snackbar = true;
          this.snackbar_color = "primary";
          this.mensaje_snackbar = "Archivo Eliminado";

          this.getArchivosPorCarpeta();
          this.limpiar();
        }
      } catch (error) {
        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = `Error eliminando ${this.nombre_archivo}:`;
        console.error(`Error eliminando ${this.nombre_archivo}:`, error);
      }
    },
    async eliminarArchivos() {
      this.dialog_progress_linear = true;

      try {
        const selectedFiles = [
          ...this.selectedFilesDUI,
          ...this.selectedFilesNIT,
          ...this.selectedFilesIVA,
          ...this.selectedFilesComprobante,
          ...this.selectedFilesFactura,
        ];

        const deletePromises = selectedFiles.map(async (file) => {
          try {
            const response = await axios.delete(
              `api/OneDrive/EliminarArchivo/${file.id}`
            );
          } catch (error) {
            this.snackbar = true;
            this.snackbar_color = "error";
            this.mensaje_snackbar = `Error eliminando ${file.name}:`;
            console.error(`Error eliminando ${file.name}:`, error);
          }
        });

        await Promise.all(deletePromises);
      } catch (error) {
        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = "Error general al crear el ZIP";
        console.error("Error general al crear el ZIP:", error);
      } finally {
        this.getArchivosPorCarpeta();
        this.dialog_progress_linear = false;
        this.limpiar();
      }
    },
    opcionEliminar(item) {
      this.dialog_eliminar = true;
      this.nombre_archivo = item.name;
      this.id_archivo = item.id;
    },
    opcionEliminarSeleccionados() {
      this.dialog_eliminar_seleccionados = true;
    },
    limpiar() {
      this.dialog_eliminar = false;
      this.dialog_eliminar_seleccionados = false;
      this.nombre_archivo = null;
      this.id_archivo = null;
    },
    ////////////////////////////////////////////////////////////////////////////
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
    formatoFechaV2(fecha) {
      return moment(fecha).format("DD-MM-YYYY");
    },
  },
};
</script>
